module.exports = __webpack_public_path__ + "static/img/sicbo2_th.d8adf1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/sicbo2_th.png
// module id = Xyo/
// module chunks = 1